// Modulo operation that matches the sign of the divisor (`limit`) rather than
// the dividend (`value`). With a positive limit, this wraps negative values
// around into the positive range [0, limit).
const mod = (limit: number) => (value: number) =>
  ((value % limit) + limit) % limit;
export const wrapHour = mod(24);
export const wrapMinute = mod(60);
